import React from 'react';
import {ThemeToggle} from './ThemeToggle';
import {Github} from 'lucide-react';

export const Header = () => {
    return (
        <header className="header">
            <div className="container">
                <div className="header-content">
                    <div className="logo">
                        <span className="logo-text">Node-Boot</span>
                        <span className="logo-subtitle">Test Framework</span>
                    </div>
                    <nav className="nav">
                        <button
                            className="theme-toggle"
                            aria-label="Toggle theme"
                        >
                            <a href="https://github.com/nodejs-boot/node-boot-test-framework" target="_blank" rel="noopener noreferrer"
                               className="nav-link-icon">
                                <Github className="w-5 h-5"/>
                            </a>
                        </button>
                        <ThemeToggle/>
                    </nav>
                </div>
            </div>
        </header>
    );
};
